import { Typography } from '@saucelabs/ds-typography';
import classnames from 'classnames';
import React, { FC } from 'react';

interface BuildSnapshotThumbIndicatorProps {
  hasBaseline: boolean;
  count: number;
}

export enum IndicatorType {
  New = 'NEW',
  Equal = 'EQUAL',
  Changed = 'CHANGED'
}

const BuildSnapshotIndicatorChanges: FC<BuildSnapshotThumbIndicatorProps> = ({
  hasBaseline,
  count,
}) => {
  const changed = count ? IndicatorType.Changed : IndicatorType.Equal;
  const type = !hasBaseline ? IndicatorType.New : changed;

  const styles: Record<IndicatorType, string> = {
    [IndicatorType.New]: 'bg-orange-50',
    [IndicatorType.Equal]: 'bg-green-50',
    [IndicatorType.Changed]: 'bg-red-50',
  };

  return (
    <div className={classnames('rounded-full px-1 h-2.5 flex items-center', styles[type])}>
      <Typography
        className="text-medium-emphasis font-semibold"
        variant="body"
      >
        {hasBaseline ? count : 'New'}
      </Typography>
    </div>
  );
};

export default BuildSnapshotIndicatorChanges;
